<p-dialog [(visible)]="dialogVisibleValue.value"
          [showHeader]="false"
          [draggable]="false"
          [dismissableMask]="true"
          [focusOnShow]="true"
          [resizable]="false"
          appendTo="body"
          [modal]="true"
          position="top"
          styleClass="command-palette-dialog">
  <div #mainContainer class="flex flex-col pt-4 command-modal-container">
    <input [(ngModel)]="searchValue.value" autofocus class="w-full mb-3" placeholder="Search Actions" pInputText />
    <ng-container *ngIf="dialogVisibleValue.value && (groups$ | async) as groups">
      <div class="command-body" [ngClass]="{ 'my-auto': !groups.length }">
        <div *ngIf="!groups.length" class="flex justify-center">
          <label>No actions {{searchValue.value ? 'match' : 'found'}}</label>
        </div>
        <div class="command-group" *ngFor="let group of groups">
          <label *ngIf="typeOf(group[0]) === 'string'">{{group[0]}}</label>
          <ng-container *ngFor="let command of group[1]">
            <div (click)="execute(command)"
                 [ngClass]="{selected: command === selected}"
                 [title]="command.title ?? ''"
                 class="command-item">
              <div *ngIf="command.icon" class="command-icon">
                <i [ngClass]="command.icon"></i>
              </div>
              <div class="command-label">
                {{ command.label }}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</p-dialog>